// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"56066c99","498":"186582a7","545":"0ead7338"}[chunkId] + ".chunk.js";
};